import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup, FormControl, Validators, AbstractControl } from '@angular/forms';

@Component({
  selector: 'kl-multiselect',
  templateUrl: './multiselect.component.html',
  styleUrls: ['./multiselect.component.scss']
})
export class MultiselectComponent implements OnInit, OnChanges {
  @Input() DropDownInfo: any;
  @Input() settings: any;
  @Input() SelectedInfo: any;
  @Output() SelectedValues: EventEmitter<any>;
  @Input() form_Control: FormControl;
  dropdownList = [];
  selectedItems = [];
  constructor() {
    this.SelectedValues = new EventEmitter<any>();
  }

  ngOnInit() {
    try {
      if (this.form_Control === undefined) {
        this.form_Control = new FormControl([], Validators.nullValidator);
      }
      if (this.SelectedInfo) {
        this.selectedSetData();
      }
      if (this.settings.DefaultSelect) {
        for (let i = 0; i < this.dropdownList.length; i++) {
          this.selectedItems.push(this.dropdownList[i]);
        }
      }
      if (!this.settings.hasOwnProperty('lazyLoading')) {
        this.settings['lazyLoading'] = true;
      }
      if (!this.settings.hasOwnProperty('badgeShowLimit')) {
        this.settings['badgeShowLimit'] = 3;
      }
    } catch (error) {
      console.error(error);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    try {
      if (changes.DropDownInfo) {
        if (changes.DropDownInfo['currentValue']) {
          this.DropDownInfo = [];
          this.DropDownInfo = changes['DropDownInfo']['currentValue'];
          this.dropdownSetData();
        }
      }
      if (changes.SelectedInfo) {
        if (changes.SelectedInfo['currentValue']) {
          this.SelectedInfo = [];
          this.SelectedInfo = changes['SelectedInfo']['currentValue'];
          this.selectedSetData();
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  dropdownSetData() {
    // this.selectedItems = [];
    try {
      if (typeof (this.DropDownInfo) === 'undefined') {
        this.DropDownInfo = [];
      }
      this.dropdownList = [];
      if (this.DropDownInfo.length > 0) {
        this.dropdownList = this.DropDownInfo;
      }
      // for (let i = 0; i < this.DropDownInfo.length; i++) {
      //   const temp = {
      //     id: this.DropDownInfo[i].value,
      //     itemName: this.DropDownInfo[i].label,
      //     key: this.DropDownInfo[i].value,
      //   };
      //   this.dropdownList.push(temp);
      // }
    } catch (error) {
      console.error(error);
    }
  }
  selectedSetData() {
    try {
      if (typeof (this.SelectedInfo) === 'string') {
        this.SelectedInfo = [this.SelectedInfo];
      } else if (typeof (this.SelectedInfo) === 'undefined') {
        this.SelectedInfo = [];
      }
      this.selectedItems = [];
      if (this.settings.fullObject === true) {
        for (let i = 0; i < this.SelectedInfo.length; i++) {
          this.selectedItems.push(this.SelectedInfo[i]);
        }
      } else {
        for (let j = 0; j < this.DropDownInfo.length; j++) {
          for (let i = 0; i < this.SelectedInfo.length; i++) {
            if (this.SelectedInfo[i] === this.DropDownInfo[j].value) {
              this.selectedItems.push(this.DropDownInfo[j]);
            }
          }
        }
      }
    } catch (error) {
      console.error(error);
    }
  }
  emitData(event) {
    try {
      if (event) {
        this.SelectedValues.emit(this.SelectedInfo);
      }
    } catch (error) {
      console.error(error);
    }
  }
  onItemSelect(item: any) {
    try {
      this.utilityFunction(item);
    } catch (error) {
      console.error(error);
    }
  }
  onItemDeSelect(item: any) {
    try {
      this.utilityFunction(item);
    } catch (error) {
      console.error(error);
    }
  }
  onSelectAll(items: any) {
    try {
      this.utilityFunction(items);
    } catch (error) {
      console.error(error);
    }
  }
  onDeSelectAll(items: any) {
    try {
      this.selectedItems = [];
      this.utilityFunction(items);
    } catch (error) {
      console.error(error);
    }
  }
  utilityFunction(items) {
    try {
      // let TempObj = {};
      const ObjectPush = [];
      if (this.settings.fullObject === true) {
        // for (let i = 0; i < this.selectedItems.length; i++) {
        //   TempObj = {
        //     label: this.selectedItems[i].itemName,
        //     value: this.selectedItems[i].key,
        //   };
        //   ObjectPush.push(TempObj);
        // }
        this.SelectedInfo = this.selectedItems;
        this.SelectedValues.emit(this.SelectedInfo);
      } else if (this.settings.fullObject === false) {
        for (let i = 0; i < this.selectedItems.length; i++) {
          // ObjectPush.push(this.selectedItems[i].key);
          ObjectPush.push(this.selectedItems[i][this.settings.primaryKey]);
        }
        this.SelectedInfo = ObjectPush;
        this.SelectedValues.emit(ObjectPush);
      }
      // this.SelectedValues.emit(this.SelectedInfo);
    } catch (error) {
      console.error(error);
    }
  }
  refreshFunc() {
    try {
      this.selectedItems = [];
    } catch (error) {
      console.error(error);
    }
  }
}
